// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"main_search_snippets-module__wrapper--1dTdl"};